<template>
  <div v-if="faqs.length" class="mt-25 mdsm:mt-0">
    <h2
      class="fs-24 font-medium mb-6 mdsm:mb-4 md:mt-16 sm:mt-15"
      data-sticky-nav-item
      id="faqs"
    >
      FAQs
    </h2>
    <div class="flex flex-col gap-4 sm:gap-3">
      <div
        v-for="faq in faqs"
        :key="faq.id"
        class="faq-panel__container px-6 rounded-lg sm:px-3 py-4 sm:py-3"
        :data-question-id="faq.id"
      >
        <div
          class="faq-panel__question cursor-pointer flex justify-between items-center"
          @click="toggleExpandCollapse($event, faq.id)"
        >
          <h4
            class="question bodytext sm:pr-4"
            itemscope
            itemprop="mainEntity"
            itemtype="https://schema.org/Question"
          >
            <div
              class="fs-16 lh-150"
              itemprop="name"
              v-html="faq.question"
            ></div>
          </h4>
          <span class="icon p-2 rounded-full bg-white w-8 h-8">
            <svg
              width="18"
              height="18"
              style="right: 10px"
              viewBox="0 0 24 24"
              fill="black"
            >
              <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
            </svg>
          </span>
        </div>
        <div
          class="faq-panel__answer hidden bodytext mt-3"
          itemscope
          itemprop="acceptedAnswer"
          itemtype="https://schema.org/Answer"
        >
          <div itemprop="text" v-html="faq.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["resortId"],
  data() {
    return {
      faqs: [],
    };
  },
  mounted() {
    window
      .fetchSupplierInfo(this.resortId)
      .then((response) => {
        if (Array.isArray(response.supplier.faqs)) {
          this.faqs = response.supplier.faqs;
        }
      })
      .then(() => {
        if (window.initStickyNav) {
          window.initStickyNav();
        }
      });
  },
  methods: {
    toggleExpandCollapse(e, faqId) {
      // collpase other opening question
      const otherActiveQuestion = $(
        `.faq-panel__container:not([data-question-id=${faqId}]).active`
      );
      if (otherActiveQuestion.length) {
        otherActiveQuestion
          .removeClass("active")
          .children(".faq-panel__answer")
          .stop()
          .slideUp(300);
      }

      $(e.currentTarget)
        .parent()
        .toggleClass("active")
        .children(".faq-panel__answer")
        .stop()
        .slideToggle(300);
    },
  },
};
</script>

<style scoped>
.faq-container__panels:not(:first-of-type) {
  margin-top: 2.5em;
}

.faq-panel__container {
  border: 2px solid #f6f6f6;
  background-color: #f6f6f6;
}

.faq-panel__question,
.icon,
.icon svg {
  transition: 0.3s;
}

.faq-panel__answer {
  color: #727272;
}

.faq-panel__answer p:last-of-type {
  margin-bottom: 0;
}

.faq__main-container hr {
  color: #e0e0e0;
}

.faq-panel__container.active .icon {
  color: white;
  background-color: #1695a3;
  transform: rotateZ(90deg);
}

.faq-panel__container.active .icon svg {
  fill: white;
}

.faq-panel__container.active {
  border: 2px solid #1695a3;
  background-color: #fff;
}
</style>
